module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//game-modal_single.png?v=1d89b65e";